import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export type MaterialThumbnailDimensions = {
    size: number
    resolution: number
}

export type MaterialThumbnailAssignmentType =
    | DataObjectAssignmentType.MaterialThumbnail_10x10
    | DataObjectAssignmentType.MaterialThumbnail_15x15
    | DataObjectAssignmentType.MaterialThumbnail_20x20
    | DataObjectAssignmentType.MaterialThumbnail_30x30
    | DataObjectAssignmentType.MaterialThumbnail_7x7Inches
    | DataObjectAssignmentType.MaterialThumbnail_8x8Inches
    | DataObjectAssignmentType.MaterialThumbnail_9x9Inches
    | DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches
    | DataObjectAssignmentType.MaterialThumbnail_16x16Inches
    | DataObjectAssignmentType.MaterialThumbnail_27x27Inches
    | DataObjectAssignmentType.MaterialThumbnail_32x32Inches

export const MATERIAL_THUMBNAIL_DIMENSIONS: Record<MaterialThumbnailAssignmentType, MaterialThumbnailDimensions> = {
    [DataObjectAssignmentType.MaterialThumbnail_10x10]: {size: 10, resolution: 3000},
    [DataObjectAssignmentType.MaterialThumbnail_15x15]: {size: 15, resolution: 3000},
    [DataObjectAssignmentType.MaterialThumbnail_20x20]: {size: 20, resolution: 3000},
    [DataObjectAssignmentType.MaterialThumbnail_30x30]: {size: 30, resolution: 3000},
    [DataObjectAssignmentType.MaterialThumbnail_7x7Inches]: {size: 17.78, resolution: 2100},
    [DataObjectAssignmentType.MaterialThumbnail_8x8Inches]: {size: 20.32, resolution: 2400},
    [DataObjectAssignmentType.MaterialThumbnail_9x9Inches]: {size: 22.86, resolution: 3000},
    [DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches]: {size: 34.29, resolution: 4050},
    [DataObjectAssignmentType.MaterialThumbnail_16x16Inches]: {size: 40.64, resolution: 4800},
    [DataObjectAssignmentType.MaterialThumbnail_27x27Inches]: {size: 68.58, resolution: 8100},
    [DataObjectAssignmentType.MaterialThumbnail_32x32Inches]: {size: 81.28, resolution: 9600},
}
